import styled from 'styled-components';

export const ResponsiveImage = styled.img`
  width: 100%;
`;

export const Picture = styled.picture`
  display: flex;
  flex-direction: column;
`;

export const Source = styled.source``;
